
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --outline-button--family--computed:var(
    --outline-button--family,
    var(--ff-bold)
  );
  --outline-button--weight--computed:var(
    --outline-button--weight,
    var(--fw-extrabold)
  );
  --outline-button--padding--computed:var(
    --outline-button--padding,
    var(--spacing-2) var(--spacing-8)
  );
  --outline-button--radius--computed:var(--outline-button--radius, 0.4rem);
}

:host{
  --outline-button--link-padding--computed:var(
    --outline-button--link-padding,
    var(--spacing-1) var(--spacing-2)
  );
  --outline-button--link-font-size--computed:var(
    --outline-button--link-radius,
    var(--fs-lg)
  );
  --outline-button--link-bg-color--computed:var(
    --outline-button--link-bg-color,
    var(--outline-transparent)
  );
  --outline-button--link-color--computed:var(
    --outline-button--link-color,
    brand var(--brand-dark-blue-900)
  );
  --outline-button--link-disabled-bg-color--computed:var(
    --outline-button--link-disabled-bg-color,
    var(--outline-transparent)
  );
  --outline-button--link-disabled-color--computed:var(
    --outline-button--link-disabled-color,
    var(--brand-gray-600)
  );
  --outline-button--link-disabled-weight--computed:var(
    --outline-button--link-disabled-weight,
    var(--fw-bold)
  );
}

:host{
  --outline-button--primary-padding--computed:var(
    --outline-button--primary-padding,
    var(--outline-button--padding--computed)
  );
  --outline-button--primary-radius--computed:var(
    --outline-button--primary-radius,
    var(--outline-button--radius--computed)
  );
  --outline-button--primary-bg-color--computed:var(
    --outline-button--primary-bg-color,
    var(--brand-bright-blue-900)
  );
  --outline-button--primary-color--computed:var(
    --outline-button--primary-color,
    var(--brand-dark-blue-900)
  );
  --outline-button--primary-weight--computed:var(
    --outline-button--primary-weight,
    var(--outline-button--weight--computed)
  );
  --outline-button--primary-bg-color-focus--computed:var(
    --outline-button--primary-bg-color-focus,
    var(--brand-bright-blue-900)
  );
  --outline-button--primary-color-focus--computed:var(
    --outline-button--primary-color-focus,
    var(--brand-dark-blue-900)
  );
  --outline-button--primary-weight-focus--computed:var(
    --outline-button--primary-weight-focus,
    var(--outline-button--weight--computed)
  );
  --outline-button--primary-ring-focus--computed:var(
    --outline-button--primary-ring-focus,
    var(--outline-ring-offset-width) solid var(--brand-dark-blue-900)
  );
  --outline-button--primary-disabled-bg-color--computed:var(
    --outline-button--primary-disabled-bg-color,
    var(--brand-gray-300)
  );
  --outline-button--primary-disabled-color--computed:var(
    --outline-button--primary-disabled-color,
    var(--brand-gray-600)
  );
  --outline-button--primary-disabled-weight--computed:var(
    --outline-button--primary-disabled-weight,
    var(--outline-button--weight--computed)
  );
}

:host{
  --outline-button--secondary-padding--computed:var(
    --outline-button--secondary-padding,
    var(--outline-button--padding--computed)
  );
  --outline-button--secondary-radius--computed:var(
    --outline-button--secondary-radius,
    var(--outline-button--radius--computed)
  );
  --outline-button--secondary-bg-color--computed:var(
    --outline-button--secondary-bg-color,
    var(--brand-dark-blue-900)
  );
  --outline-button--secondary-color--computed:var(
    --outline-button--secondary-color,
    var(--outline-white)
  );
  --outline-button--secondary-weight--computed:var(
    --outline-button--secondary-weight,
    var(--outline-button--weight--computed)
  );
  --outline-button--secondary-ring--computed:var(
    --outline-button--secondary-ring,
    var(--outline-ring-inset) 0 0 0 var(--outline-ring-offset-width)
      var(--outline-blue-600)
  );
  --outline-button--secondary-bg-color-focus--computed:var(
    --outline-button--secondary-bg-color-focus,
    var(--brand-dark-blue-900)
  );
  --outline-button--secondary-color-focus--computed:var(
    --outline-button--secondary-color-focus,
    var(--outline-white)
  );
  --outline-button--secondary-weight-focus--computed:var(
    --outline-button--secondary-weight-focus,
    var(--outline-button--weight--computed)
  );
  --outline-button--secondary-ring-focus--computed:var(
    --outline-button--secondary-ring-focus,
    2px solid var(--brand-dark-blue-900)
  );
  --outline-button--secondary-disabled-bg-color--computed:var(
    --outline-button--secondary-disabled-bg-color,
    var(--outline-white)
  );
  --outline-button--secondary-disabled-color--computed:var(
    --outline-button--secondary-disabled-color,
    var(--outline-gray-400)
  );
  --outline-button--secondary-disabled-weight--computed:var(
    --outline-button--secondary-disabled-weight,
    var(--outline-button--weight--computed)
  );
  vertical-align:middle;
  --outline-button-left-icon-container-margin-right:1.25rem;
  --outline-button-margin-left:0;
  --outline-button-right-icon-container-margin-left:1rem;
  --outline-button-rounded-border-radius:50%;
  --outline-button-rounded-width:54px;
  --outline-button-rounded-height:54px;
  --outline-button-left-icon-padding:0.4rem 2rem 0.4rem 0.4rem;
  --outline-button-extra-large-padding:1rem 2rem 1rem 0.4rem;
  --outline-button-font-family:var(--outline-button--family--computed);
  --outline-button-padding:var(--outline-button--padding--computed);
  --outline-button-accent-color:var(--brand-dark-blue-900);
  --outlne-button-icon-size:2rem;
}

.btn{
  display:inline-flex;
  flex-wrap:nowrap;
  align-items:center;
  cursor:pointer;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, outline, outline-color;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:150ms;
  text-decoration-line:none;
  outline:none;
  border:none;
  letter-spacing:1px;

  line-height:1.5;
}

.btn.white{
    --outline-button-accent-color:var(--outline-white);
  }

.btn.dropdown{
    --outline-button-padding:6px 1rem;
    --outline-button-font-family:var(--ff-body);
    --outline-button-right-icon-container-margin-left:0.25rem;
    --outline-button-accent-color:var(--brand-dark-blue-900);
  }

.btn.has-droplet-icon{
    --outline-button-margin-left:-5px;
  }

.btn{

  border-radius:var(--outline-button--radius--computed);
  font-family:var(--outline-button-font-family);
  font-weight:var(--outline-button--weight--computed);
  padding:var(--outline-button-padding);
  margin-left:var(--outline-button-margin-left);
}

.left-icon-container{
  display:flex;
  align-items:center;
  justify-content:center;
  width:var(--outlne-button-icon-size);
  max-width:var(--outlne-button-icon-size);
  height:var(--outlne-button-icon-size);
  max-height:var(--outlne-button-icon-size);
  margin-right:var(--outline-button-left-icon-container-margin-right);
  border-radius:4px;
}

.left-icon-container.droplet{
  border-radius:0;
}

.right-icon-container{
  display:flex;
  align-items:center;
  justify-content:center;
  margin-left:var(--outline-button-right-icon-container-margin-left);
}

.btn[aria-disabled='true']{
  pointer-events:none;
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none;
}

.btn.primary{
  padding:var(--outline-button--primary-padding--computed);
  border-radius:var(--outline-button--primary-radius--computed);
  background-color:var(--outline-button--primary-bg-color--computed);
  color:var(--outline-button--primary-color--computed);
  font-weight:var(--outline-button--primary-weight--computed);
  box-shadow:var(--outline-button--primary-ring--computed);
  transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.btn.primary .right-icon-container{
    transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

.btn.primary:hover{
    transform:scale(1.05);
  }

.btn.primary:hover .right-icon-container{
      transform:translateX(0.5rem);
    }

.btn.primary:focus{
    background-color:var(--outline-button--primary-bg-color-focus--computed);
    color:var(--outline-button--primary-color-focus--computed);
    font-weight:var(--outline-button--primary-weight-focus--computed);
    outline:2px solid var(--outline-button-accent-color);
    outline-offset:2px;
  }

.btn.primary.has-left-icon{
    padding:var(--outline-button-left-icon-padding);
  }

.btn.primary.has-left-icon .left-icon-container{
      color:var(--outline-white);
      background-color:var(--brand-dark-blue-900);
    }

.btn.primary.rounded{
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:var(--outline-button-rounded-border-radius);
    width:var(--outline-button-rounded-width);
    height:var(--outline-button-rounded-height);
    padding:0;
  }

.btn.primary.search-button{
    padding:0.375rem;
  }

.btn.primary.mobile{
    width:100%;
    justify-content:center;
  }

.btn.primary.extra-large{
    --outlne-button-icon-size:3.25rem;
    padding:var(--outline-button-extra-large-padding);
  }

.btn.secondary{
  padding:var(--outline-button--secondary-padding--computed);
  border-radius:var(--outline-button--secondary-radius--computed);

  background-color:var(--outline-button--secondary-bg-color--computed);
  color:var(--outline-button--secondary-color--computed);
  font-weight:var(--outline-button--secondary-weight--computed);
  transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.btn.secondary .right-icon-container{
    transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

.btn.secondary:hover{
    transform:scale(1.05);
  }

.btn.secondary:hover .right-icon-container{
      transform:translateX(0.5rem);
    }

.btn.secondary:focus{
    background-color:var(--outline-button--secondary-bg-color-focus--computed);
    color:var(--outline-button--secondary-color-focus--computed);
    font-weight:var(--outline-button--secondary-weight-focus--computed);
    outline:2px solid var(--outline-button-accent-color);
    outline-offset:2px;
  }

.btn.secondary.has-left-icon{
    padding:var(--outline-button-left-icon-padding);
  }

.btn.secondary.has-left-icon .left-icon-container{
      background-color:var(--brand-bright-blue-900);
      color:var(--brand-dark-blue-900);
    }

.btn.secondary.rounded{
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:var(--outline-button-rounded-border-radius);
    width:var(--outline-button-rounded-width);
    height:var(--outline-button-rounded-height);
    padding:0;
  }

.btn.secondary.mobile{
    width:100%;
    justify-content:center;
  }

.btn.primary[aria-disabled='true'],
.btn.secondary[aria-disabled='true']{
  background-color:var(--outline-button--primary-disabled-bg-color--computed);
  color:var(--outline-button--primary-disabled-color--computed);
  font-weight:var(--outline-button--primary-disabled-weight--computed);
}

.btn.link{
  font-family:var(--ff-display);
}

.btn.link.small-font{
    font-family:var(--ff-body);
  }

.btn.link.extra-small-font{
    font-family:var(--ff-body);
    font-size:var(--fs-sm);
  }

.btn.link{
  display:inline-flex;
  font-size:var(--outline-button--link-font-size--computed);
  padding:var(--outline-button--link-padding--computed);
  position:relative;
  border-radius:0;
  color:var(--outline-button--link-color--computed);
}

.btn.link.white{
    color:var(--outline-white);
  }

.btn.link{
  background-color:var(--outline-button--link-bg-color--computed);
}

.btn.link:before,
  .btn.link:after{
    content:'';
    position:absolute;
  }

.btn.link:after{
    background-color:var(--outline-button-accent-color);
    bottom:-0.25rem;
    height:0.25rem;
    left:0.5rem;
    transition:width 0.3s;
    width:0;
  }

.btn.link,
  .btn.link:visited,
  .btn.link:hover{
    color:var(--outline-button-accent-color);
  }

.btn.link,
  .btn.link:visited,
  .btn.link:hover,
  .btn.link:focus{
    outline:0;
    text-decoration:none;
  }

.btn.link:not(.search-button):not(.cta):hover:after{
        width:calc(100% - 1rem);
      }

.btn.link:not(.search-button):not(.cta):focus{
      background-color:var(--brand-dark-blue-900);
      color:var(--outline-white);
    }

.btn.link:not(.search-button):not(.cta):focus:before{
        background-color:var(--outline-white);
        border-top:4px solid var(--brand-dark-blue-900);
        height:8px;
        left:0;
        top:-8px;
        transition:none;
        width:100%;
      }

.btn.link:not(.search-button):not(.cta):focus:after{
        background-color:var(--outline-white);
        border-bottom:4px solid var(--brand-dark-blue-900);
        bottom:-8px;
        height:8px;
        left:0;
        transition:none;
        width:100%;
      }

.btn.link .left-icon-container{
    width:auto;
    height:auto;
    margin-right:var(--spacing-1);
  }

.btn.link .right-icon-container{
    margin-left:var(--spacing-1);
  }

.btn.link.cta{
    padding:5px 0;
    white-space:nowrap;
    letter-spacing:1px;
    line-height:1.11111;
  }

.btn.link.cta .right-icon-container{
      transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

.btn.link.cta:hover .right-icon-container{
        transform:translateX(0.5rem);
      }

.btn.link[aria-disabled='true']{
  background-color:var(--outline-button--link-disabled-bg-color--computed);
  color:var(--outline-button--link-disabled-color--computed);
  font-weight:var(--outline-button--link-disabled-weight--computed);
}

.btn.dropdown{
  border-radius:var(--outline-button--primary-radius--computed);
  background-color:var(--outline-button--primary-bg-color--computed);
  color:var(--outline-button--primary-color--computed);
  transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition:border-radius 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.btn.dropdown .right-icon-container{
    transition:transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

.btn.dropdown{
  letter-spacing:normal;
}

.btn.dropdown:before,
  .btn.dropdown:after{
    content:'';
    position:absolute;
  }

.btn.dropdown:after{
    background-color:var(--outline-button-accent-color);
    bottom:-3px;
    height:3px;
    left:0;
    transition:width 0.3s;
    width:0;
    z-index:999;
  }

.btn.dropdown,
  .btn.dropdown:visited,
  .btn.dropdown:hover{
    color:var(--outline-button-accent-color);
  }

.btn.dropdown.open .right-icon-container{
      transform:rotate(180deg);
    }

.btn.dropdown.open{
    border-radius:0.4rem 0.4rem 0 0;
}

.btn.dropdown.open:after{
      width:calc(100%);
    }

.btn.dropdown:focus-visible{
    background-color:var(--outline-button--primary-bg-color-focus--computed);
    color:var(--outline-button--primary-color-focus--computed);
    font-weight:var(--outline-button--primary-weight-focus--computed);
    outline:2px solid var(--outline-white);
    outline-offset:2px;
  }

.btn.dropdown .right-icon-container{
    margin-left:var(--spacing-3);
  }

.btn.dropdown.mobile{
    width:100%;
    justify-content:center;
  }

.outline-file-link{
  width:100%;
}

.outline-file-link .btn{
    width:100% !important;
  }

form{
  display:flex;
  flex-direction:column;
  gap:2rem;
  font-family:var(--ff-body);
}

.js-form-type-textfield,
.js-form-type-email,
.js-form-type-tel,
.js-form-type-password{
  display:flex;
  flex-direction:column;
  position:relative;
}

.js-form-type-textfield label, .js-form-type-email label, .js-form-type-tel label, .js-form-type-password label{
  }

.js-form-type-textfield.active label, .js-form-type-email.active label, .js-form-type-tel.active label, .js-form-type-password.active label{
  }

.js-form-type-textfield ::placeholder, .js-form-type-email ::placeholder, .js-form-type-tel ::placeholder, .js-form-type-password ::placeholder{
    color:var(--brand-gray-400);
  }

.js-form-type-textfield.form-disabled label, .js-form-type-email.form-disabled label, .js-form-type-tel.form-disabled label, .js-form-type-password.form-disabled label{
      color:var(--brand-gray-400);
    }

input[type='text'],
input[type='email'],
input[type='tel'],
input[type='password']{
  border:2px solid var(--brand-dark-blue-900);
  border-radius:6px;
  padding-block:0.65rem;
  padding-inline:var(--spacing-4);
  z-index:1;
  color:black;
  background-color:transparent;
}

input[type='text']:focus-visible, input[type='email']:focus-visible, input[type='tel']:focus-visible, input[type='password']:focus-visible{
    outline:1px solid var(--brand-dark-blue-900);
  }

.form-disabled input[type='text'], .form-disabled input[type='email'], .form-disabled input[type='tel'], .form-disabled input[type='password']{
    border-color:var(--brand-gray-400);
  }

.webform-element-description{
  margin-top:var(--spacing-1);
  font-size:var(--fs-xs);
  font-style:italic;
}

.form-disabled .webform-element-description{
    color:var(--brand-gray-400);
  }

.js-form-type-textarea{
  display:flex;
  flex-direction:column;
}

.js-form-type-textarea textarea{
    color:black;
    border:1px solid var(--brand-gray-700);
    padding-block:var(--spacing-2);
    padding-inline:var(--spacing-4);
  }

.js-form-type-textarea label{
    padding-bottom:var(--spacing-1);
    font-size:var(--fs-sm);
    font-family:var(--ff-display);
  }

.js-form-type-textarea div{
    display:flex;
    flex-direction:column;
  }

.js-form-type-textarea.form-disabled textarea{
      color:var(--brand-gray-400);
      border-color:var(--brand-gray-400);
    }

.js-form-type-textarea.form-disabled label{
      color:var(--brand-gray-400);
    }

.fieldset-legend{
  font-family:var(--ff-display);
  font-size:var(--fs-sm);
}

.form-disabled .fieldset-legend{
    color:var(--brand-gray-400);
  }

.js-form-type-select{
  position:relative;
}

.js-form-type-select select{
    display:none;
  }

.select-selected{
  background-color:var(--brand-white);
  border:1px solid var(--brand-gray-700);
  margin-top:var(--spacing-1);
  display:flex;
  align-items:center;
  justify-content:space-between;
}

.select-selected outline-icon{
    transition:transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

.select-selected.select-arrow-active{
    background-color:var(--brand-gray-300);
  }

.select-selected.select-arrow-active outline-icon{
      transform:rotate(180deg);
    }

.form-disabled .select-selected{
    border-color:var(--brand-gray-400);
    background-color:#fafafa;
  }

.select-items div,
.select-selected{
  color:var(--brand-gray-800);
  padding:var(--spacing-2) var(--spacing-4);
  cursor:pointer;
}

.form-disabled .select-items div, .form-disabled .select-selected{
    color:var(--brand-gray-400);
    cursor:auto;
  }

.select-items{
  position:absolute;
  background-color:var(--brand-white);
  top:100%;
  left:0;
  right:0;
  z-index:99;
  border:1px solid var(--brand-gray-700);
  border-top:none;
  max-height:250px;
  overflow-y:auto;
}

.form-disabled .select-items{
    border-color:var(--brand-gray-400);
  }

.select-hide{
  display:none;
}

.select-items div:hover,
.same-as-selected{
  background-color:var(--brand-gray-300);
}

.js-webform-radios{
  display:flex;
  flex-wrap:wrap;
  gap:var(--spacing-6);
  margin-top:var(--spacing-2);
}

.js-form-type-radio{
  display:flex;
  align-items:center;
}

.js-form-type-radio input{
    display:grid;
    place-content:center;
    cursor:pointer;
    -webkit-appearance:none;
            appearance:none;
    border:2px solid var(--brand-gray-700);
    width:var(--spacing-5);
    height:var(--spacing-5);
    border-radius:50%;
    margin-right:var(--spacing-2);
    transition:border-width 0.15s ease;
  }

.js-form-type-radio input:checked{
      border-width:6px;
    }

.js-form-type-radio input:focus-visible{
      outline-offset:4px;
    }

.js-form-type-radio input:hover,
    .js-form-type-radio input:focus{
      outline-style:solid;
      outline-color:var(--brand-dark-blue-900);
      outline-width:2px;
      border-radius:50%;
      outline-offset:4px;
    }

.js-form-type-radio.form-disabled input{
      border-color:var(--brand-gray-400);
      cursor:auto;
    }

.js-form-type-radio.form-disabled label{
      color:var(--brand-gray-400);
    }

.js-form-type-date,
.js-form-type-webform-time{
  display:flex;
  flex-direction:column;
}

.js-form-type-date input, .js-form-type-webform-time input{
    padding:var(--spacing-2) var(--spacing-4);
    display:inline-flex;
    border:1px solid var(--brand-gray-700);
  }

.js-form-type-date label, .js-form-type-webform-time label{
    font-size:var(--fs-sm);
  }

.js-form-type-date.form-disabled input, .js-form-type-webform-time.form-disabled input{
      color:var(--brand-gray-400);
      border-color:var(--brand-gray-400);
    }

.js-form-type-date.form-disabled label, .js-form-type-webform-time.form-disabled label{
      color:var(--brand-gray-400);
    }

.js-form-type-checkbox,
.facet-item{
  display:flex;
  gap:var(--spacing-3);
  align-items:center;
}

.js-form-type-checkbox .webform-element-description:before, .facet-item .webform-element-description:before{
      content:'(';
    }

.js-form-type-checkbox .webform-element-description:after, .facet-item .webform-element-description:after{
      content:')';
    }

.js-form-type-checkbox input, .facet-item input{
    display:grid;
    position:relative;
    place-content:center;
    cursor:pointer;
    -webkit-appearance:none;
            appearance:none;
    width:var(--spacing-8);
    min-width:var(--spacing-8);
    height:var(--spacing-8);
    border-radius:4px;
    border:2px solid var(--brand-dark-blue-900);
  }

.js-form-type-checkbox input:checked, .facet-item input:checked{
      background-color:var(--brand-green-900);
      border-width:3px;
    }

.js-form-type-checkbox input:checked::after, .facet-item input:checked::after{
      content:'';
      position:absolute;
      width:60%;
      height:30%;
      border:solid var(--brand-dark-blue-900);
      border-width:0 0 3px 3px;
      transform:rotate(-45deg);
      left:20%;
      top:30%;
    }

.js-form-type-checkbox input:hover,
    .js-form-type-checkbox input:focus,
    .facet-item input:hover,
    .facet-item input:focus{
      outline-style:solid;
      outline-color:var(--brand-dark-blue-900);
      outline-offset:4px;
      outline-width:2px;
      border-radius:4px;
    }

.js-form-type-checkbox.form-disabled input, .facet-item.form-disabled input{
      border-color:var(--brand-gray-400);
      cursor:auto;
    }

.js-form-type-checkbox.form-disabled label, .facet-item.form-disabled label{
      color:var(--brand-gray-400);
    }

.js-form-type-checkbox .facet-item__value, .facet-item .facet-item__value{
    font-family:var(--ff-bold);
  }

.form-actions{
  display:flex;
  padding-top:var(--spacing-8);
  justify-content:flex-end;
}

input[type='submit'],
input.webform-button--submit{
  background-color:var(--outline-button--primary-bg-color--computed);
  border-color:var(--outline-button--primary-bg-color--computed);
  border-radius:var(--outline-button--primary-radius--computed);
  color:var(--outline-button--primary-color--computed);
  cursor:pointer;
  font-family:var(--ff-display);
  padding:var(--spacing-3) var(--spacing-6);
  transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

input[type='submit']:disabled, input.webform-button--submit:disabled{
    background-color:var(--brand-gray-800);
    border:1px solid var(--brand-gray-200);
    color:var(--brand-gray-400);
  }

input[type='submit']:hover, input.webform-button--submit:hover{
    transform:scale(1.05);
  }

:host([form-type='in-page-search']){
  position:relative;
  margin-bottom:var(--spacing-16);
}

:host([form-type='in-page-search']) .form-item-search{
    border:2px solid var(--brand-dark-blue-900);
    border:var(--search-form-wrapper-border, 2px solid var(--brand-dark-blue-900));
    border-radius:6px;
  }

:host([form-type='in-page-search']) .form-item-search input[type='text']{
      max-width:calc(100% - 60px);
      max-width:var(--search-input-max-width, calc(100% - 60px));
      border:0;
      border:var(--search-input-border, 0);
      border-radius:0;
      border-radius:var(--search-input-border-radius-inner, 0);
      padding:var(--spacing-4);
      background-color:transparent;
      background-color:var(--search-input-bg-color, transparent);
    }

:host([form-type='in-page-search']) .js-form-type-textfield label{
      top:1.15rem;
    }

:host([form-type='in-page-search']) .js-form-type-textfield.active{
      outline:1px solid var(--brand-dark-blue-900);
    }

:host([form-type='in-page-search']) .js-form-type-textfield.active input{
        outline:none;
      }

:host([form-type='in-page-search']) .js-form-type-textfield.active label{
        top:-0.75rem;
      }

:host([form-type='in-page-search']) .form-actions{
    position:absolute;
    right:0;
    padding-top:var(--spacing-14);
  }

@media (min-width: 1024px){

:host([form-type='in-page-search']) .form-actions{
      padding-top:0;
      right:-7rem
  }
    }

:host([form-type='in-page-search']) .form-actions input:not(#edit-reset){
      display:none;
    }

:host([form-type='in-page-search']) .icon-wrapper{
    height:100%;
    overflow:hidden;
    position:absolute;
    right:0;
    top:auto;
    top:var(--search-icon-top, auto);
    bottom:0;
    bottom:var(--search-icon-bottom, 0);
    z-index:2;
    padding:0;
    padding-right:var(--spacing-3);
    padding-right:var(--search-icon-padding-right, var(--spacing-3));
    display:flex;
    align-items:center;
    align-items:var(--search-icon-align, center);
  }

:host([form-type='in-page-search']) .in-page-search .icon.btn{
    --outline-button--primary-padding--computed:0;
    box-shadow:var(--outline-button--primary-ring--computed);
    transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    width:40px;
    width:var(--search-button-size, 40px);
    height:40px;
    height:var(--search-button-height, var(--search-button-size, 40px));
    display:flex;
    align-items:center;
    justify-content:center;
  }

:host([form-type='in-page-search']) .in-page-search .icon.btn input:hover{
      cursor:pointer;
      transform:scale(1.05);
    }
`;